// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2eZje","header":"PatientQuestionnaire_header__20THx","info":"PatientQuestionnaire_info__cusao"};